var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_12325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 14.6668H2.66634C2.31272 14.6668 1.97358 14.5264 1.72353 14.2763C1.47348 14.0263 1.33301 13.6871 1.33301 13.3335V8.66683C1.33301 8.31321 1.47348 7.97407 1.72353 7.72402C1.97358 7.47397 2.31272 7.3335 2.66634 7.3335H4.66634M9.33301 6.00016V3.3335C9.33301 2.80306 9.12229 2.29436 8.74722 1.91928C8.37215 1.54421 7.86344 1.3335 7.33301 1.3335L4.66634 7.3335V14.6668H12.1863C12.5079 14.6705 12.8199 14.5578 13.0649 14.3495C13.31 14.1412 13.4715 13.8514 13.5197 13.5335L14.4397 7.5335C14.4687 7.3424 14.4558 7.14728 14.4019 6.96166C14.348 6.77604 14.2544 6.60436 14.1276 6.45851C14.0008 6.31265 13.8437 6.19612 13.6674 6.11697C13.4911 6.03783 13.2996 5.99797 13.1063 6.00016H9.33301Z",
    stroke: "#06308D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_12325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcThumbsUp);
export default __webpack_public_path__ + "static/media/ic-thumbs-up.49f204239cbeca7ed662e2a952830ef7.svg";
export { ForwardRef as ReactComponent };